import { jsx as l } from "react/jsx-runtime";
import { createContext as d, useState as m, useRef as M, useEffect as W, useMemo as P, useContext as i } from "react";
import { wrap as b, releaseProxy as R } from "comlink";
import C from "./index.es268.js";
import { useAPIContext as L } from "./index.es46.js";
import { usePLMapboxStoreExp as y } from "./index.es40.js";
const n = d(null), g = ({
  mapId: o,
  children: u,
  // By setting this to false, it waits for worker to be ready before loading children
  // Default to true. Optional parameter
  asyncChildrenLoading: f = !0
}) => {
  var k;
  const [p, w] = m(!1), r = M(null), { setWorkerRef: c } = y((e) => e.actions), { token: a, environment: s } = L();
  W(() => {
    const e = new C(), t = b(e);
    return r.current = {
      worker: e,
      wrappedWorker: t
    }, () => {
      r.current && (r.current.worker.terminate(), r.current.wrappedWorker && r.current.wrappedWorker[R]());
    };
  }, []), W(() => {
    (async () => {
      var t;
      (t = r.current) != null && t.wrappedWorker && (a && s && await r.current.wrappedWorker.initWorkerApiClient({
        token: a,
        environment: s
      }), w(!0));
    })();
  }, [a, s, (k = r.current) == null ? void 0 : k.wrappedWorker]);
  const x = P(() => {
    var e;
    return p && ((e = r.current) != null && e.wrappedWorker) ? (o && c({ mapId: o, workerRef: r.current.wrappedWorker }), r.current.wrappedWorker) : null;
  }, [p, o, c]);
  return /* @__PURE__ */ l(n.Provider, { value: x, children: (f || p) && u });
}, h = () => i(n), j = () => !!i(n), q = () => {
  const o = i(n);
  if (!o)
    throw new Error("Missing Worker Instance");
  return o;
};
export {
  g as PLMapboxWorkerContextProvider,
  q as useInternalPLMapboxWorker,
  j as useIsPLMapboxWorkerReady,
  h as usePLMapboxWorkerContext
};
//# sourceMappingURL=index.es39.js.map
